export default {
  routes: [
    {
      name: 'equip-certs',
      path: '/directory/equip-cert',
      component: () => import('./views/TheEquipCerts.vue'),

    },

    {
      name: 'equip-cert',
      path: '/directory/equip-cert/:uuid',
      component: () => import('./views/TheEquipCert.vue'),
    },
  ]
}
